import axios from 'axios';

export default function (context, val) {
    window.app.$confirm('Вы действительно хотите удалить счет?', 'Удаление счета №' + val.Id, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        context.commit('list/remove', val);
        axios({
            method: 'post',
            url: '/tourclient/payment/deleteInvoice?id='+val.Id,
            requestId: 'tourclient/payment/deleteInvoice'
        }).then(r => {
            window.app.$message({
                type: 'success',
                message: 'Счет удален'
            });
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        })
    }).catch(e => {
    });
}